var map = {
	"./bitcoin.png": 6353,
	"./crypto-logo-header.png": 2940,
	"./ethereum.png": 9569,
	"./litecoin.png": 9940,
	"./new-contact.png": 134,
	"./ripple.png": 7022,
	"./welcome-login.png": 7273
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4548;